import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const ReportPopupContentWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const WhatsAppButtonWrapper = styled.div`
  position: relative;

  svg {
    position: absolute;
    right: 12px;
    > path {
      fill: #40C351;
    }
  }
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    margin-top: ${theme.spacing(5)};
  `}
`;

export const ReportAddressRoot = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    width: 436px;
  `}
`;

export const WhatsAppButtonLabel = styled(SmallText)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;

export const Divider = styled.div`
  ${({ theme }) => `
    margin: ${theme.spacing(3)} 0;
    height: 1px;
    background-color: ${theme.colors.neutrals.grey8};
  `}
`;

// Report form

export const ReportFormWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  ${({ theme }) => `
    gap: ${theme.spacing(3)};
    [data-auto="textfield-label-text"] {
      color: ${theme.colors.neutrals.grey1};
    }
  `}
`;
